module.exports = __webpack_public_path__ + "img/logo-2.dffa6e41.png";